import { DialogService } from "@/service/DialogService";
import { Jikangai } from "@/types/Shinsei";
import { DateUtil } from "@/utils/DateUtil";

export function useJikangai() {
  const selectWorkTime = {
    startTime: <string | Date | null>null,
    endTime: <string | Date | null>null
  }

  const confAlert = async (jikangai: Jikangai, btnMsg: string | null = null, htmlText: string | null = null, title: string | null = null) => {
    let res = true
    if(!selectWorkTime.startTime || !selectWorkTime.endTime){
      return true
    }
    if (!jikangai.start_time || !jikangai.end_time) {
      return true
    }
    // 開始時刻
    if (DateUtil.isSameTime(jikangai.start_time.toString(), selectWorkTime.endTime.toString())
      || DateUtil.isSameTime(jikangai.start_time.toString(), selectWorkTime.startTime.toString())) {
      return true
    }
    // 終了時刻
    if (DateUtil.isSameTime(jikangai.end_time.toString(), selectWorkTime.endTime.toString())
      || DateUtil.isSameTime(jikangai.end_time.toString(), selectWorkTime.startTime.toString())) {
      return true
    }

    const startTime = DateUtil.splitTimeString(selectWorkTime.startTime.toString())
    const endTime = DateUtil.splitTimeString(selectWorkTime.endTime.toString())
    const btn = btnMsg ?? '申請する'
    const message = [
      "<p>処理を実行したい場合、" + btn + "ボタンを押下してください。</P>",
      "<br>",
      "<p>雇用契約 就業開始時刻　" + startTime?.hour + ':' + startTime?.minutes + "</p>",
      "<p>雇用契約 就業終了時刻　" + endTime?.hour + ':' + endTime?.minutes + "</p>",
    ]
    const html = htmlText ?? message.join('')
    await DialogService.warning({
      title: title ?? "開始時刻または終了時刻が雇用契約と異なります",
      html: html,
      confirmButtonText: btn,
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
    }).then((result) => {
      if (!result.isConfirmed) {
        res = false
      }
    })
    return res
  }

  return {
    selectWorkTime,
    confAlert,
  }

}
